import React from 'react'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import CheckupSmiley from './CheckupSmiley'
import { CheckupSmartview } from '../../../../widgets/smartviews/cleaning/CheckupSmartview'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

export function LatestCheckups () {
  return (
    <ValueToCollection name='latest_checkups'>
      <ForEachModel>
        <MountSmartviewWithModelOnClick smartview={<CheckupSmartview/>}>
          <CheckupSmiley name='smiley' className='cursor-pointer'/>
        </MountSmartviewWithModelOnClick>
      </ForEachModel>
    </ValueToCollection>
  )
}

export default LatestCheckups
